export default __webpack_public_path__ + "static/media/log-out.60f479ec.svg";